module.exports = __webpack_public_path__ + "static/media/seguros-fulcro-logo.3d09f7a1.svg";